/**
 * 数据表管理页面
 */
export default {
  dbl_data_table_title: "物理表",
  dbl_data_table_enter_analysis: "进入分析",
  dbl_data_table_level_one: "一级类目",
  dbl_data_table_level_two: "二级类目",
  dbl_data_table_search: "搜索表名、表描述、字段名或管理员",
  dbl_data_table_description: "描述",
  dbl_data_table_name: "名称",
  dbl_data_table_cycle: "更新周期",
  dbl_data_table_usage_count: "使用次数",
  dbl_data_table_database_type: "数据库类型",
  dbl_data_table_database_name: "数据库名称",
  dbl_data_table_creation_time: "创建时间",
  dbl_data_table_person_in_charge: "管理员",
  dbl_data_table_operation: "操作",
  dbl_data_table_analysis: "分析",
  dbl_data_table_details: "详情",
  dbl_data_table_edit: "编辑",
  dbl_data_table_structure: "表结构",
  dbl_data_table_column_name: "列名",
  dbl_data_table_data_type: "类型",
  dbl_data_table_nullable: "Nullable",
  dbl_data_table_primary_key: "主键",
  dbl_data_table_default_value: "默认值",
  dbl_data_table_comment: "注释",
  dbl_data_table_data_preview: "数据预览",
  dbl_data_table_more_three: "最多选择3个，请取消再选择",
  dbl_data_table_total: "共 {total} 项",
  dbl_data_table_tooltip: "系统表信息与数据库表信息不符，请联系数据同学与lynnhong进行校验",
  dbl_data_table_not_show: "敏感字段不展示",
  dbl_data_table_refresh_bubble: "数据表信息刷新频率默认为1h/次，点击刷新按钮将立即刷新数据表信息",
  dbl_data_table_refresh_success: "数据表信息刷新成功",
  dbl_data_table_refresh_error: "数据表信息刷新失败",
  dbl_data_table_refresh_btn: "刷新",
  dbl_data_table_not_same: "不是相同数据源不能联表",
  dbl_data_table_edit_title: "编辑数据表",
  dbl_data_table_origin_name: "原始名称",
  dbl_data_table_display_name: "显示名称",
  dbl_data_table_field_name: "字段名称",
  dbl_data_table_field_type: "字段类型",
  dbl_data_table_metric_dimension: "维度/指标",
  dbl_data_table_field_desc: "字段说明",
  dbl_data_table_dimension_value_settings: '维度值设置',
  dbl_data_table_origin: '原维度值',
  dbl_data_table_associated_dimension_table: '关联维度表',
  dbl_data_table_system: '系统自动匹配',
  dbl_data_table_customize: '自定义关联',
  dbl_data_table_include_dimension_total_value: '是否含维度汇总',
  dbl_data_table_include: '包含',
  dbl_data_table_exclude: '不包含',
  dbl_data_table_dimension: '维度',
  dbl_data_table_metric: '指标',
  dbl_data_table_string: '字符串',
  dbl_data_table_date: '日期时间',
  dbl_data_table_time: '日期时间',
  dbl_data_table_number: '整数',
  dbl_data_table_float: '小数',
  dbl_data_table_decimal_places: '小数位数',
  dbl_data_table_percent: '百分比',
  dbl_data_table_edit_leave: '离开当前数据表编辑？',
  dbl_data_table_check_date_success: '转换成功',
  dbl_data_table_check_date_fail: '无法转换为日期类型',
  dbl_data_table_size: "表容量",
};